import { createStore } from "vuex";

export default createStore({
  state: () => ({
    // estado global acá
  }),
  mutations: {
    // mutaciones acá
  },
  actions: {
    // actions acá
  },
  modules: {
    // módulos acá (ej: user, tramites, etc.)
  },
});